import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../Assets/logo.png';
import Button from '../Button/Button'; // Ensure this path is correct

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        
        {/* LEFT: Logo */}
        <div className="nav-left">
          <img src={logo} alt="ANNAI INSULATIONS" className="logo" />
        </div>

        {/* CENTER: Navigation Links */}
        <div className={`nav-center ${isOpen ? "active" : ""}`}>
          <ul className="nav-links">
            <li><a href="#home" onClick={() => setIsOpen(false)}>Home</a></li>
            <li><a href="#about" onClick={() => setIsOpen(false)}>About Us</a></li>
            <li><a href="#services" onClick={() => setIsOpen(false)}>Services</a></li>
            <li><a href="#projects" onClick={() => setIsOpen(false)}>Projects</a></li>
            <li><a href="#blogs" onClick={() => setIsOpen(false)}>Blogs</a></li>
            
            {/* Mobile-only: Using the Button Component */}
            <li className="mobile-only">
               <Button 
                text="Contact Us" 
                variant="primary" 
                size="md" 
                onClick={() => setIsOpen(false)}
               />
            </li>
          </ul>
        </div>

        {/* RIGHT: Desktop Button & Hamburger */}
        <div className="nav-right">
          <div className="desktop-only">
            <Button 
              text="Contact Us" 
              variant="primary" 
              size="md" 
            />
          </div>
          
          <div className={`hamburger ${isOpen ? "toggle" : ""}`} onClick={toggleMenu}>
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;